import React from "react";

import { Icon } from "@livingmap/hippo";
import styles from "./Thumbnail.module.css";

interface Props {
  dataQA: string;
  image: string;
  onDeleteClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClickSetOrientation?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Thumbnail: React.FC<Props> = ({
  dataQA,
  image,
  onDeleteClick,
  onClickSetOrientation,
}) => {
  return (
    <div data-qa={dataQA} className={styles.wrapper}>
      <img src={image} alt="" className={styles.image} draggable="false" />
      <button className={styles.closeButton} onClick={onDeleteClick}>
        <Icon dataQA="delete-icon" name="close" size={18} />
      </button>
      {onClickSetOrientation && (
        <button
          className={styles.orientationButton}
          onClick={onClickSetOrientation}
        >
          <Icon dataQA="set-orientation-icon" name="flag" size={18} />
        </button>
      )}
    </div>
  );
};

export default Thumbnail;
